











































































import Vue, { PropType } from 'vue'
import { Member, MessageThread, User } from '@/types';
import { getInitials } from '@/util';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import leftArrowIcon from '@/assets/icons/LeftArrowIcon.vue';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import Recepients from './Recipients.vue';
import { EventType } from '@/constants';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'RecipientPanel',
  components: {
    CloseIcon,
    InfoIcon,
    Recepients,
    leftArrowIcon
  },
  data () {
    return {
      top: 0,
      left: 0,
      EventType
    }
  },
  props: {
    selectedRecipients: {
      type: Object as PropType<any>,
      required: true
    },
    recipientSelectionError: {
      type: String,
      required: true
    },
    coBuyers: {
      type: Array as PropType<User[]>,
      required: true
    },
    teamMembers: {
      type: Array as PropType<Member[]>,
      required: true
    },
    isOpenRecipientsPanel: {
      type: Boolean,
      required: true
    },
    activeThread: {
      type: Object as PropType<MessageThread>,
      required: true
    },
    activeConversation: {
      type: String,
      required: true
    },
    isMobileDevice: {
      type: Boolean,
      required: true
    },
    isActiveThreadPostClose: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['selectedJobDetails']),
    showChooseRecipient (): boolean {
      return !this.activeConversation;
    },
    isSelectedJobPreClose (): boolean {
      return this.selectedJobDetails?.status === 'pre-close';
    },
    getApplicableRecipients (): Member[] {
      return this.isSelectedJobPreClose
        ? this.teamMembers?.filter(member => !this.isTeamMemberCustomerCareCoordinator(member) && !this.isTeamMemberCustomerCareRepresentative(member)) || []
        : this.teamMembers || [];
    }
  },
  methods: {
    isTeamMemberCustomerCareCoordinator (member: Member): boolean {
      return member.title === 'Customer Care Coordinator';
    },
    isTeamMemberCustomerCareRepresentative (member: Member): boolean {
      return member.title === 'Customer Care Representative';
    },
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    setMessageRecipients (event: any) {
      this.$emit(EventType.SET_MESSAGE_RECIPIENTS, event);
    },
    removeSelectedRecipient (id: number | string, type: 'admin' | 'buyer') {
      this.$emit(EventType.REMOVE_RECIPIENT, {
        id, type
      });
    },
    setRecipientsModalPosition (e: Event) {
      // const element = e.target as HTMLElement;
      // this.top = element.offsetTop;
      // this.left = element.offsetLeft;
      this.$emit(EventType.TOGGLE_RECIPIENTS_PANEL_STATE);
    },
    handleKeyDownOnPanel (event: any) {
      event.preventDefault();
      if (event.metaKey) {
        return true;
      }
      return false;
    },
    isTeamMemberActive (threadTeamMember: Member): boolean {
      return this.teamMembers.findIndex(member => member.email === threadTeamMember.email) > -1 && this.isActiveThreadPostClose;
    },
    isCoBuyerActive (threadCoBuyer: User): boolean {
      return this.coBuyers.findIndex(coBuyer => coBuyer.email === threadCoBuyer.email) > -1 && this.isActiveThreadPostClose;
    },
    removeRecipientBackSpace (event: any) {
      const { key } = event;
      const teamMemberLength = this.selectedRecipients.teamMembers.length;
      const coBuyerLength = this.selectedRecipients.coBuyers.length;
      if (key === 'Backspace' && teamMemberLength) {
        const lastTeamMember = this.selectedRecipients.teamMembers[teamMemberLength - 1];
        this.removeSelectedRecipient(lastTeamMember.userId, 'admin');
      } else if (key === 'Backspace' && coBuyerLength) {
        const lastCoBuyer = this.selectedRecipients.coBuyers[coBuyerLength - 1];
        this.removeSelectedRecipient(lastCoBuyer.email, 'buyer');
      }
    }
  }
})
